import {useQueryParams} from '@aboutyou/router';
import {useMemo} from 'react';
import {useDiscounts} from '../../../backend-services/Campaigns/hooks/useDiscounts';

export const useCampaignOverlay = () => {
  const {data} = useDiscounts();
  const params = useQueryParams();

  const shouldShow = Boolean(
    data?.discount && params.get('campaignOverlay') === 'true',
  );

  return useMemo(
    () => ({
      shouldShow,
      discount: data?.discount,
    }),
    [data?.discount, shouldShow],
  );
};
